// removed by extract-text-webpack-plugin
module.exports = {"flexPosition":"_1CYscEYVuDe4qShh1zPPL-","userData":"_2ORRWT6sLaIKXEMvqVDr9P","packageName":"_1gPz-4lcL2nLfOmwcZ_rgg","validUntilWrapper":"_1ZPt4zjbZwpbzryjHpPlVP","topBlockText":"_3eNhIKJGO6NiUcs2v62RsT","days":"_1_xiWOUB03iyMFfq8ueZ9w","remainingProps":"_37GZrjKZOODG1pQIq2STEm","boldText":"_2Nhr4HehlWIBy4_OQzMGaj","updateBtn":"_3A03JfALAhNaw0ThLOfjRp","updateBtnText":"_29Ji0A3p5ulIQw0wxyoEMt"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/ManagePropertiesForAgent/components/TopBlock.scss
// module id = 1812
// module chunks = 0